import { defaultApi } from "./api";
import { BASE_URL, IMAGE_BASE_URL, POPUP_MODAL_URL } from "./constant";

function getApiOrigin() {
  try {
    return new URL(BASE_URL).origin;
  } catch (error) {
    return "";
  }
}

function buildPopupImageCandidates(imagePath) {
  if (!imagePath) {
    return [];
  }

  if (/^https?:\/\//i.test(imagePath)) {
    return [imagePath];
  }

  const apiOrigin = getApiOrigin();
  const normalizedPath = imagePath.replace(/^\/+/, "");
  const withoutUploadsPrefix = normalizedPath.replace(/^uploads\/+/, "");
  const candidates = [
    `${BASE_URL}/${normalizedPath}`,
    `${IMAGE_BASE_URL}/${withoutUploadsPrefix}`,
  ];

  if (apiOrigin) {
    candidates.push(`${apiOrigin}/${normalizedPath}`);
    candidates.push(`${apiOrigin}/uploads/${withoutUploadsPrefix}`);
  }

  return [...new Set(candidates.filter(Boolean))];
}

export async function getPopupModalDetails() {
  const res = await defaultApi.get(POPUP_MODAL_URL);
  const modalData = res.data?.data;

  if (!res.data?.status || !modalData?.status) {
    return null;
  }

  const imageCandidates = buildPopupImageCandidates(modalData.image);

  return {
    ...modalData,
    image_url: imageCandidates[0] || "",
    image_candidates: imageCandidates,
  };
}
